import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaShoppingCart } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { addToCart } from "../../../redux/cartSlice";
import { IoAdd } from "react-icons/io5";
import { FiMinus } from "react-icons/fi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toggleCart } from "../../../redux/shopSlice";

const ProductInfo = ({ productInfo, aspectRatio }) => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedLot, setSelectedLot] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null);
  const [selectedCupsize, setSelectedCupsize] = useState(null);

  const display_stock = Number(sessionStorage.getItem("display_stock"));

  const productQty =
    useSelector((state) =>
      state?.cartReducer?.products?.find(
        (item) =>
          item._id === productInfo?.product_id &&
          (item?.color?.g_color || null) === (selectedColor?.g_color || null) &&
          (item?.size?.g_size || null) === (selectedSize?.g_size || null) &&
          (item?.lot?.lotno || null) === (selectedLot?.lotno || null) &&
          (item.cupsize?.g_cupsize || null) ===
            (selectedCupsize?.g_cupsize || null),
      ),
    )?.quantity || 0;

  useEffect(() => {
    if (parseInt(productInfo?.sub_type) === 8) {
      setSelectedColor(productInfo?.sub_items?.color?.[0] || null);
      setSelectedSize(productInfo?.sub_items?.size?.[0] || null);
      setSelectedCupsize(productInfo?.sub_items?.cupsize?.[0] || null);
    } else {
      if (
        parseInt(productInfo?.sub_type) === 1 ||
        parseInt(productInfo?.sub_type) === 2
      ) {
        setSelectedColor(productInfo?.sub_items?.color?.[0] || null);
      }
      if (
        parseInt(productInfo?.sub_type) === 1 ||
        parseInt(productInfo?.sub_type) === 3
      ) {
        setSelectedSize(productInfo?.sub_items?.size?.[0] || null);
      }
      if (parseInt(productInfo?.sub_type) === 5) {
        setSelectedLot(productInfo?.sub_items?.stock?.[0] || null);
      }
    }
  }, [productInfo]);

  useEffect(() => {
    if (
      !productInfo ||
      !productInfo?.sub_items ||
      (parseInt(productInfo?.sub_type) !== 1 &&
        parseInt(productInfo?.sub_type) !== 2 &&
        parseInt(productInfo?.sub_type) !== 3 &&
        parseInt(productInfo?.sub_type) !== 5 &&
        parseInt(productInfo?.sub_type) !== 8)
    ) {
      setSelectedStock(Number(productInfo?.stock?.replace(/,/g, "")));

      return;
    }

    const { stock } = productInfo?.sub_items;
    if (stock) {
      const matchingStock = stock.find(
        (stockItem) =>
          stockItem.g_size === selectedSize?.g_size &&
          stockItem.g_color === selectedColor?.g_color &&
          stockItem.lotno === selectedLot?.lotno &&
          stockItem.g_cupsize === selectedCupsize?.g_cupsize,
      );

      setSelectedStock(Number(matchingStock?.qty?.replace(/,/g, "")) || 0);
    } else {
      setSelectedStock(0);
    }
  }, [selectedColor, selectedSize, selectedLot, selectedCupsize, productInfo]);

  const precision = productInfo?.stockprec || 0; // Default precision to 0 if not provided
  const step = Math.pow(10, -precision); // Calculate step based on precision
  // Regex to enforce allowed precision
  const maxRegex = new RegExp(`^\\d*(\\.\\d{0,${precision}})?$`);

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    const parsedValue = parseFloat(value);
    if (
      value === "" ||
      (!isNaN(parsedValue) && maxRegex.test(value) && parsedValue >= 0)
    ) {
      setQuantity(parseFloat(value));
    }
  };

  const handleIncrease = () => {
    setQuantity((prev) => (prev ? parseFloat((prev + 1).toFixed(1)) : 1));
  };

  const handleDecrease = () => {
    setQuantity((prev) => (prev >= 1 ? parseFloat((prev - 1).toFixed(1)) : 0));
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();

    const {
      sub_type,
      product_id,
      name,
      product,
      images,
      meas,
      selling_price,
      product_disc_pc,
      discounted_selling_price,
      // selling_price_cur, // Removed unused variable
      stockprec,
      currency,
    } = productInfo;
    // Ensure quantity is valid
    if (quantity <= 0) {
      toast.error("Quantity must be greater than zero.", { autoClose: 2000 });
      return;
    }

    // Validate selections based on sub_type
    const validationErrors = {
      1:
        !selectedColor || !selectedSize
          ? "Please select a color and size."
          : null, // Both color and size
      2: !selectedColor ? "Please select a color." : null, // Only color
      3: !selectedSize ? "Please select a size." : null, // Only size
      8:
        !selectedColor || !selectedSize || !selectedCupsize
          ? "Please select a color, size and cup size."
          : null,
    };

    const error = validationErrors[sub_type];
    if (error) {
      toast.error(error, { autoClose: 2000 });
      return;
    }

    const payload = {
      _id: product_id,
      name: product,
      title: name,
      quantity,
      meas: meas,
      stock: selectedStock,
      image: images[0]?.path,
      disc_perc: product_disc_pc,
      original_price: selling_price,
      price: discounted_selling_price,
      aspect_ratio: aspectRatio,
      precision: stockprec,
      cur: currency,
      ...(Number(sub_type) & { color: selectedColor }), // Add color only
      ...(Number(sub_type) === 3 && { size: selectedSize }), // Add size only
      ...(Number(sub_type) === 5 && { lot: selectedLot }), //Add lot only
      ...(Number(sub_type) === 8 && {
        color: selectedColor,
        size: selectedSize,
        cupsize: selectedCupsize,
      }), //cup size
      ...(Number(sub_type) === 1 && {
        color: selectedColor,
        size: selectedSize,
      }), //cup size
    };

    // Dispatch to cart
    dispatch(addToCart(payload));

    // Show success toast
    toast.success(
      <div
        className="flex flex-col gap-1"
        onClick={() => dispatch(toggleCart())}
      >
        <div className="flex items-center gap-2">
          <FaShoppingCart size={18} className="text-black" />
          <span className="text-black font-medium flex items-center justify-center">
            <span className="font-semibold">{quantity}</span>
            <IoClose size={20} />
            <span className="font-semibold">{product}&nbsp;</span>added to cart!
          </span>
        </div>
      </div>,
      {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        style: {
          backgroundColor: "#f9f9f9",
          color: "#333333",
          width: "fit-content",
          padding: "16px 16px",
          borderRadius: "8px",
        },
        icon: false,
      },
    );
  };

  const price = parseFloat(productInfo?.selling_price?.replace(/,/g, "")) || 0;
  const disc_price =
    parseFloat(productInfo?.discounted_selling_price?.replace(/,/g, "")) || 0;
  return (
    <div className="flex flex-col xl:flex-row gap-4 ">
      <div className="w-full xl:w-2/3 flex flex-col gap-2 flex-1">
        <div className="space-y-1 pr-1">
          <p className="text-lg text-black font-semibold break-words">
            {productInfo?.product}
          </p>
          <p className=" break-words">{productInfo?.name}</p>
          <p className="text-sm pb-4">{productInfo?.description}</p>
          <div className="flex justify-between lgl:w-2/3">
            {display_stock === 1 && (
              <>
                {Number(productInfo?.stock?.replace(/,/g, "")) > 0 ? (
                  <p className="text-center my-auto">
                    {String(selectedStock) ||
                      Number(productInfo?.stock?.replace(/,/g, ""))}{" "}
                    {productInfo?.unit}
                  </p>
                ) : (
                  <p className=" font-medium text-red-600">Out Of Stock</p>
                )}
              </>
            )}
            {display_stock === 2 &&
              (Number(productInfo?.stock?.replace(/,/g, "")) > 0 &&
              selectedStock > 0 ? (
                <p className="font-medium">Available</p>
              ) : (
                <p className="font-medium text-red-600">Out Of Stock</p>
              ))}
            <div>
              {productInfo?.product_disc_pc &&
              productInfo?.discounted_selling_price &&
              disc_price !== price ? (
                <div className="flex flex-row-reverse items-start gap-4">
                  {/* Original Price */}
                  <div>
                    <p>
                      <span className="font-semibold line-through decoration-red-500 text-red-500">
                        {productInfo?.selling_price_cur}{" "}
                      </span>
                      <span className="line-through decoration-red-500 text-red-500">
                        {" "}
                        {productInfo?.selling_price}
                      </span>
                    </p>
                    {/* Discount Price */}
                    <p>
                      <span className="font-semibold ">
                        {productInfo?.selling_price_cur}{" "}
                      </span>
                      <span>{productInfo?.discounted_selling_price}</span>
                    </p>
                  </div>
                  <div className="bg-green-500 text-white aspect-square p-2 my-auto  rounded-full flex items-center justify-center text-sm font-bold">
                    {Number(productInfo?.product_disc_pc)?.toFixed(0)}%
                  </div>
                </div>
              ) : (
                // Display only the original price if no discount
                price >= 0 && (
                  <p>
                    <span className="font-semibold ">
                      {productInfo?.selling_price_cur}{" "}
                    </span>
                    {productInfo?.selling_price}
                  </p>
                )
              )}
            </div>
          </div>
        </div>

        {/* Colors Section */}
        {(parseInt(productInfo?.sub_type) === 1 ||
          parseInt(productInfo?.sub_type) === 2 ||
          parseInt(productInfo?.sub_type) === 8) && (
          <div>
            <p className="font-medium text-base mb-2">Color:</p>
            <div className="flex gap-4 flex-wrap">
              {productInfo?.sub_items?.color.map((color) => (
                <div
                  key={color?.g_color}
                  onClick={() => setSelectedColor(color)}
                  className="flex flex-col items-center"
                >
                  {/* Color Circle */}
                  <div
                    className={`w-8 h-8 rounded-full cursor-pointer border-2 ${
                      selectedColor === color
                        ? "border-black"
                        : "border-gray-300"
                    }`}
                    style={{ backgroundColor: color?.hex_code }}
                  />
                  {/* Color Name */}
                  <p
                    className={`text-xs mt-1 text-gray-600 ${
                      selectedColor === color ? "font-semibold" : ""
                    }`}
                  >
                    {color?.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Sizes Section */}
        {(parseInt(productInfo?.sub_type) === 1 ||
          parseInt(productInfo?.sub_type) === 3 ||
          parseInt(productInfo?.sub_type) === 8) && (
          <div>
            <p className="font-medium text-base mb-2">Size:</p>
            <div className="flex flex-wrap gap-2">
              {productInfo?.sub_items?.size?.map((size) => (
                <button
                  key={size?.g_size}
                  onClick={() => setSelectedSize(size)}
                  className={`px-3 py-1 border rounded cursor-pointer text-sm ${
                    selectedSize === size
                      ? "bg-black text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  {size?.name}
                </button>
              ))}
            </div>
          </div>
        )}
        {/* lot section */}
        {parseInt(productInfo?.sub_type) === 5 && (
          <div>
            <p className="font-medium text-base mb-2">Lotno:</p>
            <div className="flex flex-wrap gap-2">
              {productInfo?.sub_items?.stock?.map((lot) => (
                <button
                  key={lot?.lotno}
                  onClick={() => setSelectedLot(lot)}
                  className={`p-1 border rounded cursor-pointer text-sm ${
                    selectedLot === lot
                      ? "bg-black text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  {lot?.lotno}
                </button>
              ))}
            </div>
          </div>
        )}
        {parseInt(productInfo?.sub_type) === 8 && (
          <div>
            <p className="font-medium text-base mb-2">Cup Size:</p>
            <div className="flex flex-wrap gap-2">
              {productInfo?.sub_items?.cupsize?.map((cup) => (
                <button
                  key={cup?.g_cupsize}
                  onClick={() => setSelectedCupsize(cup)}
                  className={`px-3 py-1 border rounded text-sm cursor-pointer ${
                    selectedCupsize === cup
                      ? "bg-black text-white"
                      : "bg-gray-200 text-black"
                  }`}
                >
                  {cup?.name}
                </button>
              ))}
            </div>
          </div>
        )}
        <div className="w-full rounded-lg text-sm  relative">
          <div className="flex gap-6">
            {/* Stock */}
            {[1, 2, 3, 5, 8].includes(parseInt(productInfo?.sub_type)) &&
              Number(productInfo?.stock?.replace(/,/g, "")) > 0 && (
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-gray-600">
                    {
                      {
                        1: "Total Color and Size: ",
                        2: "Total Color: ",
                        3: "Total Size: ",
                        5: "Total Lot: ",
                        8: "Total Color, Size & Cup Size: ",
                      }[parseInt(productInfo?.sub_type)]
                    }
                  </span>

                  <span className="relative cursor-pointer ">
                    {Number(productInfo?.stock?.replace(/,/g, ""))}
                  </span>
                  <span>{productInfo?.unit}</span>
                </div>
              )}
          </div>
          {/* Quantity Control and Add to Cart Button */}
          <div className="w-full flex  items-center py-1 gap-4 text-base">
            {/* Quantity Control */}
            <div className="flex items-center gap-2">
              <div className="relative h-10 border-[1px] border-gray-300 rounded-md overflow-hidden flex items-center">
                <button
                  onClick={handleDecrease}
                  className="absolute left-0 w-8 h-full bg-gray-100  flex items-center justify-center hover:bg-gray-300 cursor-pointer duration-300"
                >
                  <FiMinus size={18} />
                </button>
                <input
                  type="number"
                  value={quantity}
                  min="0"
                  step={step}
                  onChange={handleQuantityChange}
                  className="w-28 text-center px-8 border-none outline-none"
                />
                <button
                  onClick={handleIncrease}
                  className="absolute right-0 w-8 h-full bg-gray-100  flex items-center justify-center hover:bg-gray-300 cursor-pointer duration-300"
                >
                  <IoAdd fontWeight={1} size={18} />
                </button>
              </div>
            </div>

            {/* Add to Cart Button */}
            <button
              type="button"
              onClick={handleAddToCart}
              disabled={
                (display_stock === 1 &&
                  (quantity > selectedStock - productQty || quantity === 0)) ||
                (display_stock === 2 && selectedStock <= 0)
              }
              className={`w-40 h-10 flex items-center justify-center transition-all duration-300 rounded-md ${
                (display_stock === 1 &&
                  (quantity > selectedStock - productQty || quantity === 0)) ||
                (display_stock === 2 && selectedStock <= 0)
                  ? "bg-gray-300 text-gray-400 cursor-not-allowed"
                  : "bg-primeColor text-white cursor-pointer active:border-[#146c54]"
              }`}
            >
              <span
                className={`font-semibold ${
                  (display_stock === 1 &&
                    (quantity > selectedStock - productQty ||
                      quantity === 0)) ||
                  (display_stock === 2 && selectedStock <= 0)
                    ? "text-gray-400"
                    : ""
                }`}
              >
                Add to Cart
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="w-fit max-sm:mx-auto h-fit bg-gray-50 border rounded-lg p-2 shadow-md">
        <div className="space-y-2 text-sm">
          {/* Main Info Fields */}
          <table className="w-full border-collapse">
            <tbody>
              {/* Main Info */}
              {productInfo?.main_info &&
                Object.entries(productInfo.main_info).map(
                  ([key, data], index) => {
                    if (!data) return null; // Skip null values
                    const { name, value } = data;
                    return (
                      <tr key={index} className="border-b  text-xs md:text-sm">
                        <td className=" p-2 text-gray-600 font-medium capitalize align-top max-w-[120px] md:max-w-[150px] break-words">
                          <p className="font-semibold">
                            {name ||
                              key
                                ?.replace("_", " ")
                                ?.replace("name", "")
                                ?.trim()}
                          </p>
                        </td>
                        <td className="p-2 align-top text-gray-600">:</td>
                        <td className="text-gray-700 max-w-[125px]  lg:max-w-[120px] break-words align-top p-2">
                          {value || "N/A"}
                        </td>
                      </tr>
                    );
                  },
                )}

              {/* Additional Fields */}
              {productInfo?.additional_fields &&
                productInfo.additional_fields.map((field, index) => (
                  <tr key={index} className="border-b  text-xs md:text-sm">
                    <td className="p-2 text-gray-600 font-medium capitalize align-top max-w-[120px] md:max-w-[150px] break-words">
                      <p className="font-semibold">{field.name}</p>
                    </td>
                    <td className="p-2 align-top text-gray-600">:</td>
                    <td className="text-gray-700 max-w-[125px] lg:max-w-[120px] break-words align-top p-2">
                      {field.value || "N/A"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
